import axios from "axios";
import { Env } from "../styles";

/** معرّف طلب الإجازة من أي شكل سجل */
export function resolveVacationId(vac) {
  const id = Number(vac?.id ?? vac?.vid ?? vac?.vac_id);
  return Number.isFinite(id) && id > 0 ? id : null;
}

/** حذف طلب إجازة كامل (كل أيام الفترة) */
export function deleteVacationById(vacationId) {
  const id = Number(vacationId);
  if (!Number.isFinite(id) || id <= 0) {
    return Promise.reject(new Error("invalid vacation id"));
  }
  return axios.delete(`${Env.HOST_SERVER_NAME}delete-task/${id}`);
}
